<template>
    <div>

    	<div class="mb-5">

			<h3 class="mb-4">Leistungen</h3>

			<table class="table">
			  <thead class="thead-dark">
			    <tr>
			      <th scope="col">Leistung</th>
			      <th scope="col">Beschreibung</th>
			      <th scope="col">Dauer (in min)</th>
			      <th scope="col"></th>
			    </tr>
			  </thead>
			  <tbody>
			  	<tr v-for="service in services">
					<td>{{ service.name }}</td>
					<td>{{ service.description }}</td>
					<td>{{ service.duration }}</td>
					<td></td>
				</tr>
			  </tbody>
			</table>

		</div>

    </div>
</template>

<script>
    export default {

    	data() {
            return {
				services: []
            };
        },

        mounted() {
            console.log('Component mounted.');
            
            //var servicearray = JSON.stringify(this.servicedata);
            console.log(this.servicedata);
            this.services = JSON.parse(this.servicedata);
            console.log(servicearray);
        },

        methods: {

        },

		props: {
			servicedata: {
				
			}
		},

    }
</script>
